import React from 'react'
import { ChartHeaderLayout } from '../../layouts/ChartHeaderLayout/ChartHeaderLayout'
import { ChartDeepAnalitics } from '../../components/ChartDeepAnalitics/ChartDeepAnalitics'

export const ChartDeepAnaliticsPage = () => {
    return (
        <ChartHeaderLayout chart="true" chartDetail={true} chartProject={true}>
            <ChartDeepAnalitics />
        </ChartHeaderLayout>
    )
}
